export const TRANSITION_STATE = 'TRANSITION_STATE';
export const TRANSITION_END = 'TRANSITION_END';
export const TRANSITION_TARGET = 'TRANSITION_TARGET';
export const TRANSITION_ORIGIN = 'TRANSITION_ORIGIN';

export const transitionState = transition => ({
  type: TRANSITION_STATE,
  transitionState: transition
});
export const transitionTarget = target => ({ type: TRANSITION_TARGET, target });
export const transitionOrigin = origin => ({ type: TRANSITION_ORIGIN, origin });

export const transitionStart = () => {
  return async dispatch => {
    await dispatch(transitionState('entering'));
    await setTimeout(() => dispatch(transitionState('entered')), 200);
  };
};

export const transitionEnd = () => {
  return async dispatch => {
    await dispatch(transitionState('exiting'));
    await setTimeout(() => dispatch(transitionState('exited')), 200);
  };
};

export const transitionTimeChange = (target, origin, cb) => {
  return async dispatch => {
    await dispatch(transitionTarget(target));
    await dispatch(transitionOrigin(origin));

    await dispatch(transitionStart(cb));
  };
};
